export default __webpack_public_path__ + "static/media/data-update.3c0e8ae3.svg";